import React from 'react';
import StaffManagement from '../components/StaffManagement';

const StaffManagementPage = () => {
    return <StaffManagement />;
};

export default StaffManagementPage;